import { render, staticRenderFns } from "./records.vue?vue&type=template&id=951458f8&scoped=true"
import script from "./records.vue?vue&type=script&lang=js"
export * from "./records.vue?vue&type=script&lang=js"
import style0 from "./records.vue?vue&type=style&index=0&id=951458f8&prod&lang=css"
import style1 from "./records.vue?vue&type=style&index=1&id=951458f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "951458f8",
  null
  
)

export default component.exports